import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";

import StockDetailChart from "../Components/StockDetailChart";

import TimeControl from "../Components/TimeControl";
import IndicatorSelector from "../Components/IndicatorSelector";
4;

import { useTheme } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import { Button, Divider } from "@mui/material";
import StockCompareChart from "../Components/StockCompareChart";

const PairChartsPage = () => {
  let [searchParams, setSearchParams] = useSearchParams();

  const [symbol, setSymbol] = useState("");
  const [symbol2, setSymbol2] = useState("");
  const [noData, setNoData] = useState(true);
  const [loading, setLoading] = useState(true);

  const [symbolField, setSymbolField] = useState("");
  const [symbol2Field, setSymbol2Field] = useState("");

  const theme = useTheme();

  useEffect(() => {
    const symbol = searchParams.get("symbol") || "";
    const symbol2 = searchParams.get("symbol2") || "";
    if (symbol2) {
      setSymbol2(symbol2);
      setSymbol2Field(symbol2);
    }
    if (symbol.length > 0) {
      setSymbol(symbol);
      setSymbolField(symbol);
    }
    if (!symbol2 || !symbol) {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (
      symbol !== undefined &&
      symbol !== null &&
      symbol.length > 0 &&
      symbol2 !== undefined &&
      symbol2 !== null &&
      symbol2.length > 0
    ) {
      setLoading(false);
      setNoData(false);
      console.log(symbol);
    }
  }, [symbol, symbol2]);

  const handeSaveClick = () => {
    // setIndexStock(indexField);
    setSymbol(symbolField);
    setSymbol2(symbol2Field);
  };

  useEffect(() => {
    if (!loading) {
      let params = new URLSearchParams(searchParams);
      if (symbol.length > 0) {
        if (params.get("symbol")) {
          if (params.get("symbol") !== symbol) {
            params.delete("symbol");
            params.append("symbol", symbol);
            setSearchParams(params);
          }
        } else {
          params.append("symbol", symbol);
          setSearchParams(params);
        }
      } else {
        if (params.get("symbol")) {
          params.delete("symbol");
          setSearchParams(params);
        }
      }
      if (symbol2.length > 0) {
        if (params.get("symbol2")) {
          if (params.get("symbol2") !== symbol2) {
            params.delete("symbol2");
            params.append("symbol2", symbol2);
            setSearchParams(params);
          }
        } else {
          params.append("symbol2", symbol2);
          setSearchParams(params);
        }
      } else {
        if (params.get("symbol2")) {
          params.delete("symbol2");
          setSearchParams(params);
        }
      }
    }
  }, [symbol, symbol2, searchParams, setSearchParams]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        paddingLeft: "10px",
        paddingRight: "30px",
        paddingTop: "20px",
        minHeight: "100vh",
        minWidth: "100vw",
        width: "fit-content",
        background: `${theme.palette.background.default}`,
      }}
    >
      <Stack direction="row" spacing={2}>
        <TextField
          style={{ width: "300px" }}
          id="outlined-basic"
          label="Symbol 1"
          variant="outlined"
          value={symbolField}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handeSaveClick();
            }
          }}
          onChange={(e) => {
            setSymbolField(e.target.value);
          }}
        />
        <TextField
          style={{ width: "300px" }}
          id="outlined-basic"
          label="Symbol 2"
          variant="outlined"
          value={symbol2Field}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handeSaveClick();
            }
          }}
          onChange={(e) => setSymbol2Field(e.target.value)}
        />
        <Button variant="outlined" onClick={handeSaveClick}>
          Save
        </Button>
      </Stack>
      {/* <IndicatorSelector /> */}
      <Typography component="h1" color="white">
        {symbol}
      </Typography>
      {loading && <CircularProgress />}
      {noData && symbol !== "" && <Typography>No data was received</Typography>}
      {symbol !== null &&
        symbol !== undefined &&
        symbol2 !== undefined &&
        symbol2 !== null && (
          <>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <StockCompareChart
                title="1 Day"
                symbol1={symbol}
                symbol2={symbol2}
                width={600}
                height={300}
                time="1"
              ></StockCompareChart>
              <StockCompareChart
                title="3 Day"
                symbol1={symbol}
                symbol2={symbol2}
                width={600}
                time="3"
                height={300}
              ></StockCompareChart>
              <StockCompareChart
                title="5 Day"
                symbol1={symbol}
                symbol2={symbol2}
                time="5"
                width={600}
                height={300}
              ></StockCompareChart>
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <StockCompareChart
                title="Daily"
                symbol1={symbol}
                symbol2={symbol2}
                width={600}
                time="365"
                height={300}
              ></StockCompareChart>
              <StockCompareChart
                title="Weekly"
                symbol1={symbol}
                symbol2={symbol2}
                width={600}
                time="730"
                height={300}
              ></StockCompareChart>
              <StockCompareChart
                title="Montly"
                symbol1={symbol}
                symbol2={symbol2}
                time="1825"
                width={600}
                height={300}
              ></StockCompareChart>
            </div>
            <Typography component="h1" color="white">
              {`${symbol}/${symbol2}`}
            </Typography>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <StockDetailChart
                title="1 Day"
                symbol={`${symbol}/${symbol2}`}
                width={600}
                height={600}
                time="1"
              ></StockDetailChart>
              <StockDetailChart
                title="3 Day"
                symbol={`${symbol}/${symbol2}`}
                width={600}
                time="3"
                height={600}
              ></StockDetailChart>
              <StockDetailChart
                title="5 Day"
                symbol={`${symbol}/${symbol2}`}
                time="5"
                width={600}
                height={600}
              ></StockDetailChart>
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <StockDetailChart
                title="Daily"
                symbol={`${symbol}/${symbol2}`}
                width={600}
                height={600}
                time="365"
              ></StockDetailChart>
              <StockDetailChart
                title="Weekly"
                symbol={`${symbol}/${symbol2}`}
                width={600}
                time="730"
                height={600}
              ></StockDetailChart>
              <StockDetailChart
                title="Montly"
                symbol={`${symbol}/${symbol2}`}
                time="1825"
                width={600}
                height={600}
              ></StockDetailChart>
            </div>
          </>
        )}
    </div>

  );
};

export default PairChartsPage;
